/**
 * TopBarIconButton — reusable circular icon button for the top navigation bar.
 *
 * 1:1 copy of the chamama-booking-app `neo-icon-btn` pattern:
 * — 56 px circle, 2px border, theme surface bg
 * — No shadow at rest
 * — 2px 2px offset shadow on hover (pure CSS)
 * — transition: all 0.2s ease
 */

import { cn } from '@brainsway/ui';
import { ICON_BUTTON, TOPBAR_COLORS } from './constants';
import type { TopBarIconButtonProps } from './types';

export function TopBarIconButton({
  onClick,
  children,
  badge,
  overflow = false,
  active = false,
  className,
  ...rest
}: TopBarIconButtonProps) {
  return (
    <div className={cn('relative', className)}>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'neo-icon-btn flex items-center justify-center rounded-full',
          overflow && 'overflow-hidden p-0',
          active && 'neo-icon-btn-active',
        )}
        style={{
          width: ICON_BUTTON.size,
          height: ICON_BUTTON.size,
          backgroundColor: ICON_BUTTON.bg,
          color: TOPBAR_COLORS.text,
        }}
        {...rest}
      >
        {children}
      </button>
      {badge}
    </div>
  );
}
